import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyFormFieldAppearance as MatFormFieldAppearance } from '@angular/material/legacy-form-field';

/**
 * Interface pour un groupe d'options
 */
export interface OptionGroup {
  label: string;
  items: any[];
}

@Component({
  selector: 'form-select-input',
  templateUrl: './form-select-input.component.html',
  styleUrls: ['./form-select-input.component.scss'],
})
export class SelectInputComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() controlName: string;
  @Input() label: string;
  @Input() appearance: MatFormFieldAppearance = 'outline';
  @Input() items: any[] = [];
  @Input() itemGroups: OptionGroup[] = []; // Support des groupes
  @Input() displayProperty: string;
  @Input() readonly = false;
  @Input() loading = false;
  @Input() hint = '';
  @Input() icon: any;
  @Input() defaultErrorMessage: any;
  @Input() invalidPatternMessage: string;
  @Input() customErrorMessage: string;
  @Input() withoutPadding = false;
  @Input() getProperties: (value: any) => string;
  @Output() onSelectItems = new EventEmitter();

  /**
   * Vérifie si on utilise des groupes
   */
  get hasGroups(): boolean {
    return this.itemGroups && this.itemGroups.length > 0;
  }
}
